<script>
  import { getContext } from 'svelte';

  import { calculateTotalPrice } from '../utils/pricing.js';
  import { productDataStore } from '../stores/ProductData.js';
  import { productSummaryStore } from '../stores/ProductSummary.js';

  import Modal from './Modal.svelte';
  import BulkPricingTable from '../components/Product/BulkPricingTable.svelte';

  export let show = false;

  export let arrayOfSelectedProducts = [];

  const defaultBulkDiscounts = getContext('defaultBulkDiscounts');

  const productSpecificDiscounts = $productDataStore[$productDataStore.showing]?.bulkDiscounts;

  const bulkDiscounts = productSpecificDiscounts?.length ? productSpecificDiscounts : defaultBulkDiscounts;

  const orderIncludesEmbroidery = arrayOfSelectedProducts.some((product) => {
    const details = $productSummaryStore[product];
    return details.includesEmbroidery;
  });

  const calculateBasePriceInCents = (productType) => {
    const details = $productSummaryStore[productType];
    const priceInfo = calculateTotalPrice({
      basePrice: details.product.price,
      designElements: details.designElements,
      qty: 1,
      sponsorship: details.sponsorship,
      discountTiers: bulkDiscounts,
    });
    return priceInfo.unitPrice;
  };
</script>

<Modal bind:show widthLg={true}>
  {#if arrayOfSelectedProducts && arrayOfSelectedProducts.length}
    {#each arrayOfSelectedProducts as product}
      <BulkPricingTable
        title={$productDataStore?.[product].name}
        selectedProductType={product}
        basePriceInCents={calculateBasePriceInCents(product)}
        discounts={bulkDiscounts}
        showFrontBackPrintPricing={false}
        showInclusions={false}
      />
    {/each}
  {/if}
  <div class="inclusions">
    <div class="info">All inclusive pricing includes:</div>
    <ul>
      <li><b>FREE</b> Standard Shipping orders over $500</li>
      <li><b>FREE</b> Logo Design</li>
      <li><b>FREE</b> Design Mockups</li>
      <li><b>FREE</b> Artwork Review</li>
      <li><b>FREE</b> Artwork Setup</li>
      <li>Dedicated Customer Service Rep</li>
    </ul>
  </div>

  {#if orderIncludesEmbroidery}
    <div class="embroidery-note">
      <b>NOTE:</b> Your order contains Embroidery. There is a first time setup fee of <b>$50.00</b> for new embroidered
      logos.<br />
      If applicable, the setup fee will be <b>invoiced separately</b> after your order is placed.<br />
    </div>
  {/if}
</Modal>

<style>
  .inclusions {
    margin-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 2.4rem;
  }
  .inclusions .info {
    margin-bottom: 1rem;
  }

  .embroidery-note {
    font-size: 1.4rem;
    text-align: center;
    margin-top: 2rem;
  }
</style>
